import { render, staticRenderFns } from "./ayarlar.vue?vue&type=template&id=aafdc71a"
import script from "./ayarlar.vue?vue&type=script&lang=js"
export * from "./ayarlar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports